export const formatOpeningHours = (openingHours) => {
    if (!Array.isArray(openingHours)) return []

    const grouped = []

    openingHours.forEach((entry) => {
        if (!Array.isArray(entry.days) || !Array.isArray(entry.hours)) return

        const key = entry.hours.join(' - ')
        const existing = grouped.find((g) => g.hours === key)

        if (existing) {
            existing.days.push(...entry.days)
        } else {
            grouped.push({hours: key, days: [...entry.days]})
        }
    })

    return grouped.map(({days, hours}) => {
        const formattedDays = days
            .map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3))
            .join(' - ')
        const [startRaw, endRaw] = hours.split(' - ')
        const start = formatHour(startRaw)
        const end = formatHour(endRaw)

        return {days: formattedDays, timeRange: `${start} - ${end}`}
    })
}

export const formatHour = (hourStr) => {
    if (!hourStr || typeof hourStr !== 'string') return hourStr

    const [hRaw, mRaw] = hourStr.split(':')
    const h = Number(hRaw)
    const m = Number(mRaw)

    if (isNaN(h) || isNaN(m)) return hourStr

    const isPM = h >= 12
    const hour = h % 12 === 0 ? 12 : h % 12
    const minutes = m.toString().padStart(2, '0')

    return `${hour}:${minutes} ${isPM ? 'PM' : 'AM'}`
}
